<div class="flex-row gap-2 flex-wrap m-3">
  @for (def of definitions; track def) {
      <sm-overview-box class="col-2" [count]="def.resultCount" [text]="def.name" [icon]="def.icon" [boxColor]="def.boxColor" (click2)="click(def)">
    </sm-overview-box>  
  }
</div>